<template>
  <div class="page-content wish_bets_pages">
    <div v-if="wishBetAuthorizationToken">
      <h1 v-if="!showPageTitleInHeader || (showPageTitleInHeader && tabletAndAbove)">{{ $t('PageTitle.placedbets' )}}</h1>
      <v-btn class="scan_bet_btn" @click="openBarcodeScanner()">
        <span class="barcode_icon"></span>
        <span>{{ $t('WishBet.ScanBarcode' )}}</span>
      </v-btn>
    </div>
  </div>
</template>
<script>
  import store from '@/store'
  import Screen from '@/components/mixins/Screen'
  import mobileBridge from '@/library/mobileBridge'

  export default {
    name: 'PlacedBetsPage',

    mixins: [
      Screen
    ],

    components: {
    },

    computed: {
      showPageTitleInHeader () {
        return window.ctsautoconf.PAGE_TITLE_IN_HEADER_ON_MOBILE || false
      },
      wishBetAuthorizationToken () {
        return store.getters['wishBets/wishBetAuthorizationToken']
      }
    },
    methods: {
      openBarcodeScanner () {
        console.log('open barcode scanner')
        mobileBridge.bridgeSendRequest('openBarcodeScaner')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.wish_bets_pages
  height 100vh
>>>.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat)
  &.scan_bet_btn
    width 200px
    display flex
    margin 100px auto 0 auto
    color #fff
    background #003764
    background-color #003764
    height auto
    padding 5px
    .v-btn__content
      text-align center
      flex-direction: column

.barcode_icon
  background-image url('~@/assets/images/brands/generic/wishBet/barcode_scan_icon_white.svg')
  width: 35px !important
  height: 30px !important
  margin 5px 0

</style>



// WEBPACK FOOTER //
// src/components/pages/WishBet/PlacedBetsPage.vue